import { Button, Col, Typography } from "antd";
import { EyeOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { TableColumns, TableProperties } from "../../../../shared/components/ui/Table/types";
import { ProgramStudentType } from "../../../../types/dto/program";
import Table from "../../../../shared/components/ui/Table";
import { programsStudentAcademy } from "../../../../shared/services";
import useDeleteStudents from "../../hooks/students/useDeleteStudents";
import { useNavigate } from "react-router-dom";
import React from "react";
import { ModalEditStudentProgram } from "../../../../shared/components/ui/modals/ModalEditStudentProgram";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux";
import { isRestrictedTeacher } from "../../../../shared/utils/roles";
import moment from "moment";
import { ProgramStudentStatusBadge } from "../../../../shared/components/ui/AcademyStatusBadge";

const { Title } = Typography;

interface TableProgramProps {
  program_id: number;
  onTableReady?: (properties: TableProperties) => void;
}

export const TableProgramStudent = ({
  program_id,
  onTableReady,
}: TableProgramProps) => {
  const [showModalEditStudentProgram, setShowModalEditStudentProgram] =
    React.useState<boolean>(false);
  const [programStudentId, setProgramStudentId] = React.useState<number>();
  const [tableInstance, setTableInstance] =
    React.useState<TableProperties>();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const refreshTable = React.useCallback(() => {
    tableInstance?.refresh();
  }, [tableInstance]);

  const { showDeleteConfirm } = useDeleteStudents({
    onSuccess: refreshTable,
  });

  const handleTableLoad = React.useCallback(
    (properties: TableProperties) => {
      setTableInstance(properties);
      onTableReady?.(properties);
    },
    [onTableReady]
  );

  const hanldeRedirectPersonalInfo = (user_id: number) => {
    navigate(`/gestion-academy/personal-info/${user_id}/${program_id}`);
  };

  const columns: TableColumns<ProgramStudentType> = [
    {
      title: "Codigo",
      width: 2,
      dataIndex: "q",
      filterType: "text",
      filterWay: "$client",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              {item?.user?.student_code}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Usuario",
      width: 2,
      dataIndex: "q",
      filterType: "text",
      filterWay: "$client",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              {`${item?.user?.first_name} ${item?.user?.last_name}`}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Email",
      width: 2,
      dataIndex: ["user", "email"],
      key: "email",
    },
    {
      title: "Telefono",
      width: 2,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              {item?.user?.phone}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Fecha de matricula",
      width: 2,
      render: (_, item) => {
        if (!item?.enrollment_date) return null;
        return (
          <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
            {moment(item?.enrollment_date).format("DD/MM/YYYY")}
          </Title>
        );
      },
    },
    {
      title: "Estado",
      width: 2,
      dataIndex: "status",
      filterType: "base",
      filterMultiple: false,
      filters: [
        { text: "Activo", value: "active" },
        { text: "Inactivo", value: "inactive" },
        { text: "Pausado", value: "pause" },
        { text: "Completado", value: "completed" },
      ],
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
          }}
        >
          <ProgramStudentStatusBadge status={item.status} />
        </Col>
      ),
    },
    {
      title: "Acciones",
      key: "operation",
      width: 2,
      fixed: "right",
      render: (_, item: ProgramStudentType) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
              gap: 15,
            }}
          >
            <Button
              type="primary"
              shape="circle"
              icon={<EyeOutlined />}
              size="large"
              onClick={() => hanldeRedirectPersonalInfo(item.user_id)}
            />
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="large"
              onClick={() => {
                setProgramStudentId(item.id);
                setShowModalEditStudentProgram(true);
              }}
            />
            {!isRestrictedTeacher(user?.role) && (
              <Button
                type="primary"
                shape="circle"
                danger
                onClick={() => {
                  showDeleteConfirm(item.id, "");
                }}
                icon={<DeleteOutlined />}
                size="large"
              />
            )}
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <ModalEditStudentProgram
        programStudentId={+programStudentId!}
        openModal={showModalEditStudentProgram}
        setOpenModal={setShowModalEditStudentProgram}
        onSuccess={refreshTable}
      />

      <Table<ProgramStudentType>
        columns={columns}
        scroll={{}}
        fetchQueryProps={{
          program_id,
          $sort: { id: -1 },
        }}
        onLoad={handleTableLoad}
        service={programsStudentAcademy}
      />
    </>
  );
};
